import React from "react";
import { Edit, SimpleForm, TextField, TextInput } from "react-admin";

const LocationEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextField source="id" />
        <TextInput label="Name" source="name" />
        <TextInput label="Stable ID" source="stableId" />
        <TextInput label="Location Abbreviation" source="abbr" />
      </SimpleForm>
    </Edit>
  );
};

export default LocationEdit;
